module.exports = __webpack_public_path__ + "static/media/cloud_4.d47b2881.png";